__turbopack_context__.v({
  "caret": "b0JoJq_caret",
  "caretBlink": "b0JoJq_caretBlink",
  "input": "b0JoJq_input",
  "inputFilled": "b0JoJq_inputFilled",
  "resultRow": "b0JoJq_resultRow",
  "results": "b0JoJq_results",
  "rise": "b0JoJq_rise",
  "riseIn": "b0JoJq_riseIn",
  "riseInner": "b0JoJq_riseInner",
  "send": "b0JoJq_send",
  "sendArmed": "b0JoJq_sendArmed",
});
